import { Button, Flex, Grid, GridItem, Heading } from "@chakra-ui/react";
import { useEffect } from "react";
import { CustomViewOfferPriceListAddNew } from "./addNew";
import { Provider } from "./context";
import { CustomViewOfferPriceListList } from "./list";

export const CustomViewOfferPriceList = () => {
  // Ustawienie tytułu strony
  useEffect(() => {
    document.title = "Cenniki ofert";
  }, []);

  return (
    <Provider>
      <CustomViewOfferPriceListList />
    </Provider>
  );
};
